import AppDispatcher from '../dispatcher/AppDispatcher';
import UserManagementConstants from '../constants/UserManagementConstants';

export default class UserManagementActionCreator {
  static getUserDetails() {
    AppDispatcher.handleViewAction({
      actionType: UserManagementConstants.REQUEST_USER_DETAILS,
    });
  }

  static handleUserDetailsSuccess(response) {
    AppDispatcher.handleServerAction({
      actionType: UserManagementConstants.REQUEST_USER_DETAILS_SUCCESS,
      data: response,
    });
  }

  static handleUserDetailsError(error) {
    AppDispatcher.handleServerAction({
      actionType: UserManagementConstants.REQUEST_USER_DETAILS_ERROR,
      data: error,
    });
  }
}
